import Immutable from 'seamless-immutable';
import createReducer from '../helpers/createReducer';
import state from '../store/zone';

export default createReducer(state, {
  SET_ZONESTR: (state, { data }) => Immutable({ ...state, zoneStr: data }),
  SET_ZONEARY: (state, { data }) => Immutable({ ...state, zoneAry: data }),
  SET_PROMPTS: (state, { data }) => Immutable({ ...state, prompts: data }),
  SET_COORDINATE: (state, { data }) => Immutable({ ...state, coordinate: data }),
  SET_COUNTRY_NAME: (state, { data }) => Immutable({ ...state, countryName: data }),
  SET_FULL_ADDRESS: (state, { data }) => Immutable({ ...state, fullAddress: data }),
  SET_MAP_CITY_NAME: (state, { data }) => Immutable({ ...state, mapCityName: data }),
  SET_EXAMPLEADDRESS: (state, { data }) => Immutable({ ...state, exampleAddress: data }),
  SET_GOOGLESEARCHTERM: (state, { data }) => Immutable({ ...state, googleSearchTerm: data }),
});
